module.exports = __webpack_public_path__ + "img/katarina_events_13.6981e055.jpg";